// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-box[data-v-201c36db] {\n  border-top: 6px solid #f6f7f9;\n}\n.title-tips[data-v-201c36db] {\n  color: #999;\n  font-size: 12px;\n  margin-top: 8px;\n}\n.title-bar[data-v-201c36db] {\n  padding: 20px 0 0 15px;\n  color: #333333;\n  font-size: 14px;\n  font-family: PingFang SC-Regular, PingFang SC;\n  font-weight: 400;\n  position: relative;\n}", ""]);
// Exports
module.exports = exports;
